/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from "react";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import _ from "lodash";
import moment from "moment";
//import "bootstrap/less/bootstrap.less";
import {Bar, Pie} from "react-chartjs-2";
import {SERVER} from "./Redux/actions/actionType";
import {Redirect} from "react-router-dom";
import {connect} from "react-redux";

let YYYY = new Date().getFullYear();
let MM = new Date().getMonth() + 1;
let DD = new Date().getDate();
let date_ =
  YYYY + "" + (MM < 10 ? "0" + MM : MM) + "" + (DD < 10 ? "0" + DD : DD);
const data1 = {
  labels: ["Caraibe", "Magik 9", "Metropole", "Melodie", "Sky"],
  datasets: [
    {
      data: [300, 50, 100, 258, 158],
      backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#a8e4b1", "306d75"],
      hoverBackgroundColor: [
        "#FF6384",
        "#36A2EB",
        "#FFCE56",
        "#a8e4b1",
        "306d75",
      ],
    },
  ],
};

class Head extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      musics: [],
      musicsTmp: [],
      allMusic: [],
      title: localStorage.getItem("title", ""),
      radio: "280319",
      artist: localStorage.getItem("artist", ""),
      date: {YYYY, MM, DD},
      startDate: new Date(),
      activePage: 0,
      parPage: 20,
      loading: true,
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.musics.length !== this.state.musics.length) {
      console.log("new data...");
      this.setState({allMusic: _.chunk(this.state.musics, 50)});
    }
  }
  nextPrev = (dat) => {
    let YYYY = dat.getFullYear();
    let MM = dat.getMonth() + 1;
    let DD = dat.getDate();

    let date_ =
      YYYY + "" + (MM < 10 ? "0" + MM : MM) + "" + (DD < 10 ? "0" + DD : DD);

    this.setState({musics: []});
    let self = this;
    axios
      .get(
        `https://cors-anywhere.herokuapp.com/https://api.acrcloud.com/v1/acrcloud-monitor-streams/${this.state.radio}/results?access_key=a54f67369a4ce05e49c8af7263f1831d&date=${date_}`
      )
      .then(function (response) {
        console.log(response);
        if (response && response.data && !response.data.error) {
          self.setState({
            musics: _.chunk(self.filtre(response.data), self.state.parPage),
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  componentDidMount() {
    let self = this;

    axios
      .get(`${SERVER}/stats?_limit=1000`)
      .then(function (response) {
        console.log(response);
        self.setState({
          musics: response.data,
          musicsTmp: response.data,
          loading: false,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  handleChange = (date) => {
    this.setState(
      {
        startDate: date,
      },
      () => {
        this.nextPrev(new Date(date));
      }
    );
  };
  handlePageChange(pageNumber) {
    console.log(`active page is ${pageNumber}`);
    this.setState({activePage: pageNumber});
  }
  filtre = (arr) => {
    return arr
      .filter((d) =>
        JSON.stringify(d.metadata.music[0].title)
          .toLowerCase()
          .includes(this.state.title.toLowerCase())
      )
      .filter((d) =>
        JSON.stringify(d.metadata.music[0].artists)
          .toLowerCase()
          .includes(this.state.artist.toLowerCase())
      );
  };
  refresh = () => {
    //alert(this.state.radio);

    this.setState({musics: [], loading: true});
    let self = this;
    axios
      .get(
        `https://cors-anywhere.herokuapp.com/https://api.acrcloud.com/v1/acrcloud-monitor-streams/${this.state.radio}/results?access_key=a54f67369a4ce05e49c8af7263f1831d&date=${date_}`
      )
      .then(function (response) {
        console.log(response);
        if (response && response.data && !response.data.error) {
          self.setState({
            musics: _.chunk(self.filtre(response.data), self.state.parPage),
            loading: false,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
        this.setState({loading: false});
      });
  };

  render() {
    if (
      this.props.user &&
      (!this.props.user.user || this.props.user.user.role_user !== "author")
    ) {
      // window.location.href = "/dashboard";
      return <Redirect to={"/dashboard"} />;
    } else {
      return (
        <div>
          <main className="page-wrapper" style={{marginTop: 100}}>
            <label className="col-md-3" style={{margin: 10}}>
              <h2>{this.state.artist + " - " + this.state.title}</h2>
            </label>

            <div
              className="row"
              style={{marginRight: 20, marginLeft: 20, paddingTop: 10}}></div>
          </main>
          <div style={{marginLeft: 20, marginRight: 40, minHeight: 300}}>
            <ListenView author={this.state.artist} title={this.state.title} />
          </div>
        </div>
      );
    }
  }
}

class ListenView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activePage: 0,
      musics: [],
      allMusic: [],
      author: "",
      title: "",
      groupsByRadio: [],
      groupsByDay: [],
      radio: "235480",
      loading: true,
    };
  }

  componentDidMount() {
    let self = this;

    let a = 1;

    //  var refreshIntervalId = setInterval(() => {
    axios
      .get(`${SERVER}/stats?_limit=1000`)
      .then(function (response) {
        console.log(response);

        // if (response.data.length < 200) {
        //   clearInterval(refreshIntervalId);
        // }

        let rrrr = self.filtre(
          _.concat(self.state.musics, response.data),
          self.props.author,
          self.props.title
        );
        var groups = _.groupBy(rrrr, function (date) {
          return moment(date.data.metadata.timestamp_utc)
            .startOf("day")
            .format();
        });

        var result = _.map(groups, function (group, day) {
          return {
            day: day,
            times: group,
          };
        });

        var groups2 = _.groupBy(rrrr, function (date) {
          return date.data.radio.label;
        });

        var result2 = _.map(groups2, function (group, radio) {
          return {
            radio: radio,
            data: group,
          };
        });

        self.setState({
          musics: self.filtre(
            _.concat(self.state.musics, response.data),
            self.props.author,
            self.props.title
          ),
          musicsTmp: self.filtre(
            _.concat(self.state.musics, response.data),
            self.props.author,
            self.props.title
          ),
          groupsByDay: _.orderBy(result, ["day"], ["asc"]),
          groupsByRadio: result2,
          loading: false,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
    //   a = a + 100;
    // }, 1000);

    // axios
    //   .get(`${SERVER}/stats?_limit=2000`)
    //   .then(function (response) {

    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.musics.length !== this.state.musics.length) {
      console.log("new data...");
      this.setState({allMusic: _.chunk(this.state.musics, 10)});
      console.log(this.state.groupsByDay);
    }
  }

  setAll = () => {
    for (let i = 0; i < this.state.musics.length; i++) {
      let music = this.state.musics[i].metadata.music[0];

      //console.log(JSON.stringify(music, null, 2));
    }
  };
  listen = (radio, date, author, title) => {
    let self = this;

    let date_ =
      date.getFullYear() +
      "" +
      (date.getMonth() < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      "" +
      (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());

    axios
      .get(
        `https://cors-anywhere.herokuapp.com/https://api.acrcloud.com/v1/acrcloud-monitor-streams/${radio}/results?access_key=a54f67369a4ce05e49c8af7263f1831d&date=${date_}`
      )
      .then(function (response) {
        var other = _.concat(
          self.state.musics,
          self.filtre(response.data, author, title)
        );
        self.setState({musics: other});
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  filtre = (arr, artist, title) => {
    return arr
      ? arr
          .filter((d) =>
            JSON.stringify(d.data.metadata.music[0].title)
              .toLowerCase()
              .includes(title.toLowerCase())
          )
          .filter((d) =>
            JSON.stringify(d.data.metadata.music[0].artists)
              .toLowerCase()
              .includes(artist.toLowerCase())
          )
      : [];
  };
  render() {
    const {allMusic} = this.state;
    return (
      <div>
        <div className="row">
          <div className=" col-lg-6">
            {this.state.groupsByDay && this.state.groupsByDay.length > 0 ? (
              <Bar
                data={{
                  labels: this.state.groupsByDay.map((i) =>
                    i.day.substring(0, 10)
                  ),
                  datasets: [
                    {
                      label: "Diffusion",
                      backgroundColor: "rgba(255,99,132,0.2)",
                      borderColor: "rgba(255,99,132,1)",
                      borderWidth: 1,
                      hoverBackgroundColor: "rgba(255,99,132,0.4)",
                      hoverBorderColor: "rgba(255,99,132,1)",
                      data: this.state.groupsByDay.map((i) => i.times.length),
                    },
                  ],
                }}
                width={100}
                height={500}
                options={{
                  maintainAspectRatio: false,
                }}
              />
            ) : (
              <Bar
                data={{
                  labels: [],
                  datasets: [
                    {
                      label: "Diffusion " + this.props.title,
                      backgroundColor: "rgba(255,99,132,0.2)",
                      borderColor: "rgba(255,99,132,1)",
                      borderWidth: 1,
                      hoverBackgroundColor: "rgba(255,99,132,0.4)",
                      hoverBorderColor: "rgba(255,99,132,1)",
                      data: [],
                    },
                  ],
                }}
                width={100}
                height={500}
                options={{
                  maintainAspectRatio: false,
                }}
              />
            )}
          </div>

          <div className=" col-lg-6">
            <br />
            {this.state.groupsByRadio && this.state.groupsByRadio.length > 0 ? (
              <Pie
                data={{
                  labels: this.state.groupsByRadio.map((i) => i.radio),
                  datasets: [
                    {
                      data: this.state.groupsByRadio.map((i) => i.data.length),
                      backgroundColor: [
                        "#FF6384",
                        "#36A2EB",
                        "#FFCE56",
                        "#a8e4b1",
                        "306d75",
                      ],
                      hoverBackgroundColor: [
                        "#FF6384",
                        "#36A2EB",
                        "#FFCE56",
                        "#a8e4b1",
                        "306d75",
                      ],
                    },
                  ],
                }}
              />
            ) : (
              <Pie
                data={{
                  labels: [""],
                  datasets: [
                    {
                      data: [1],
                      backgroundColor: [
                        "#FF6384",
                        "#36A2EB",
                        "#FFCE56",
                        "#a8e4b1",
                        "306d75",
                      ],
                      hoverBackgroundColor: [
                        "#FF6384",
                        "#36A2EB",
                        "#FFCE56",
                        "#a8e4b1",
                        "306d75",
                      ],
                    },
                  ],
                }}
              />
            )}
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-bordered table-dark">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Date</th>
                <th scope="col">Titre</th>
                <th scope="col">Album</th>
                <th scope="col">Artiste</th>
                <th scope="col" style={{width: 150}}>
                  Radio
                </th>
              </tr>
            </thead>

            {allMusic.length > 0 ? (
              <tbody>
                {allMusic[this.state.activePage].map((item, index) => {
                  let music = item.data.metadata.music[0];
                  return (
                    <tr key={index}>
                      <th scope="row">
                        {(this.state.activePage > 0
                          ? this.state.activePage * 10
                          : 0) +
                          index +
                          1}
                      </th>
                      <th style={{width: 200}}>
                        {item.data.metadata.timestamp_utc}
                      </th>
                      <td>{music.title}</td>
                      <td>{music.album.name}</td>
                      <td>{music.artists[0].name}</td>
                      <td>{item.data.radio.label}</td>
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody style={{minHeight: 100}}></tbody>
            )}
          </table>
          <center>
            {this.state.loading === true ? <p>Loading.....</p> : null}
          </center>
          {allMusic.length > 0 ? (
            <nav aria-label="Page navigation example">
              <ul class="pagination">
                <li class="page-item">
                  <a
                    onClick={() =>
                      this.setState({
                        activePage:
                          this.state.activePage > 1
                            ? this.state.activePage - 1
                            : 0,
                      })
                    }
                    class="page-link"
                    aria-label="Previous"
                    style={{cursor: "pointer"}}>
                    <span aria-hidden="true">&laquo;</span>
                  </a>
                </li>
                {this.state.allMusic.map((i, index) => {
                  if (index < 20)
                    return (
                      <li
                        class={
                          this.state.activePage === index
                            ? "page-item active"
                            : "page-item"
                        }
                        style={{cursor: "pointer"}}
                        onClick={() => this.setState({activePage: index})}>
                        <a class="page-link">{index + 1}</a>
                      </li>
                    );
                })}

                <li
                  class="page-item"
                  style={{cursor: "pointer"}}
                  onClick={() =>
                    this.setState({
                      activePage:
                        this.state.activePage < allMusic.length - 1
                          ? this.state.activePage + 1
                          : allMusic.length - 1,
                    })
                  }>
                  <a class="page-link" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                  </a>
                </li>
              </ul>
            </nav>
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.user,
    stats: state.user.stats,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Head);
